module.exports = __webpack_public_path__ + "img/USER_FINISHED.bfb9ed17.svg";